"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  "2 S": "2s",
  "2 in 1": "2-in-1",
  "all in one": "All-in-One",
  "omen x": "OMEN X",
  "4 K": "4K",
  "3 D": "3D",
  "8 K": "8K",
  "hp z": "HP Z",
  "11 T": "11t",
  "12 T": "12t",
  "13 T": "13t",
  "14 T": "14t",
  "15 T": "15t",
  "17 T": "17t",
  "x 360": "x360",
  "x 2": "x2",
  "I 3": "i3",
  "I 5": "i5",
  "I 7": "i7"
};